import { ViewColumn } from 'common/types/viewColumn';
import { ExtraOptions } from '../types';
import { map, each, isNil, keyBy, get } from 'lodash';
import { Row } from './type';
import { agGridDataFormatter } from 'common/visualizations/views/agGridReact/helpers/TableColumnFormatting';
import { GridApi, ICellRendererParams } from '@ag-grid-community/core';

interface FormatRowDataArgs {
  rowData: Row[];
  gridApi: GridApi;
  columns: ViewColumn[];
  extraOptions: ExtraOptions;
}

// Tried doing it in the print preview worker. But the DataTypeFormatter requires
// jQuery and i18n. So for now, formatting the table cell content in the main thread.
// Later: Probably, we can create a generic DataTypeFormatter that takes
// sanitizeHTML/currencySymbol as inputs.
// - original DataTypeFormatter will use jquery/I18n for sanitizeHTML/currencySymbol
// - web worker DataTypeFormatter where we will pass a new sanitizeHTML and pass
//  currencySymbol to webWorker from mainThread
export const formatRows = ({ rowData, columns, extraOptions, gridApi }: FormatRowDataArgs) => {
  const { dataset, nonStandardAggregations, columnFormats } = extraOptions;
  const allDisplayedColumns = gridApi.getAllDisplayedColumns();
  const rowGroupCols = gridApi.getRowGroupColumns();
  const columnsById = keyBy(allDisplayedColumns.concat(rowGroupCols), (col: any) => col.getColId());

  return map(rowData, (rowDatum: Row & any) => {
    const newRowDatum: any = { ...rowDatum };

    each(columns, (columnItem) => {
      const value = rowDatum[columnItem.fieldName!];
      const columnDef = get(columnsById, [columnItem.fieldName, 'colDef']);
      const newColumnParams: ICellRendererParams = {
        ...columnDef,
        colDef: columnDef,
        value,
        valueFormatted: value
      };

      if (!isNil(value)) {
        const formattedValue = agGridDataFormatter(
          dataset.domain,
          dataset.datasetUid,
          columns,
          nonStandardAggregations,
          newColumnParams,
          columnFormats
        );
        newRowDatum[columnItem.fieldName!] = formattedValue;
      }
    });

    return newRowDatum;
  });
};
